import { useEffect, useRef, useState } from "react";
import { PhotoItem } from "ztypes/feed";

const STANDARD_SCREEN_WIDTH = 320;
const MAX_PHOTO = 9;
const COLUMN = 3;
const PADDING = 2;

interface ImageGalleryProps {
  photos: PhotoItem[];
}

interface ImageProps {
  ratio: number;
  photo: PhotoItem;
}

const Image: React.FC<ImageProps> = (props) => {
  const ratio = props.ratio;
  const photo = props.photo;
  const top = photo.layout.top * ratio;
  const right = photo.layout.right * ratio;
  const bottom = photo.layout.bottom * ratio;
  const left = photo.layout.left * ratio;
  const style = {
    objectFit: "cover",
    width: right - left,
    height: bottom - top,
    top: top,
    right: right,
    bottom: bottom,
    left: left,
  } as React.CSSProperties;
  return <img className="absolute" src={photo.thumb} style={style} />;
};

const ImageGallery: React.FC<ImageGalleryProps> = (
  photos: ImageGalleryProps
) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [ratio, setRatio] = useState<number>(1);
  useEffect(() => {
    function handleResize() {
      if (ref && ref.current && ref.current.getBoundingClientRect().width > 0) {
        setRatio(
          ref.current.getBoundingClientRect().width / STANDARD_SCREEN_WIDTH
        );
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []); 

  var listPhoto: PhotoItem[] = photos.photos;
  const totalPhoto = listPhoto.length;
  if (totalPhoto > MAX_PHOTO) {
    listPhoto = listPhoto.slice(0, MAX_PHOTO + 1);
  }
  const maxHeight2Photo =  listPhoto.length == 2?`${Math.max(listPhoto[0].layout.bottom, listPhoto[1].layout.bottom) * ratio}px`:""
  return (
    <div ref={ref} className="relative w-full aspect-square" style={{height: maxHeight2Photo}}>
      {listPhoto.map((photo, index) => {
        if (index < MAX_PHOTO) {
          return <Image key={index} ratio={ratio} photo={photo} />;
        } else {
          const top = listPhoto[index - 1].layout.top * ratio;
          const right = listPhoto[index - 1].layout.right * ratio;
          const bottom = listPhoto[index - 1].layout.bottom * ratio;
          const left = listPhoto[index - 1].layout.left * ratio;
          const style = {
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            position: "absolute",
            zIndex: 9999,
            width: right - left,
            height: bottom - top,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
          } as React.CSSProperties;
          return <div className="flex justify-center items-center text-white font-medium" style={style}>+{totalPhoto - MAX_PHOTO + 1}</div>;
        }
      })}
    </div>
  );
};

export default ImageGallery;
